import { render, staticRenderFns } from "./ColorPickerItem.vue?vue&type=template&id=0065143e&scoped=true"
import script from "./ColorPickerItem.vue?vue&type=script&lang=js"
export * from "./ColorPickerItem.vue?vue&type=script&lang=js"
import style0 from "./ColorPickerItem.vue?vue&type=style&index=0&id=0065143e&prod&scoped=true&lang=scss"
import style1 from "./ColorPickerItem.vue?vue&type=style&index=1&id=0065143e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0065143e",
  null
  
)

export default component.exports